import ChatbotWidget from "./ChatbotWidget";
import { AuthProvider } from "./AuthProvider";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ManageQna from "./ManageQna";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* main widget */}
            <Route path="/" element={<ChatbotWidget />} />

            {/* login → same widget but with Add Q&A visible */}
            <Route path="/login" element={<ChatbotWidget />} />

            {/* Manage panel */}
            <Route path="/manage-qna" element={<ManageQna />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
